import { getClientBySlug, type IClientTheme } from '@/clients/clientRegistry';
import { applyClientTheme } from '@/utils/applyClientTheme';
import { defineStore } from 'pinia';
import { ref } from 'vue';

const useClientStore = defineStore('client', () => {
    const theme = ref<IClientTheme>(getClientBySlug('default'));

    function setTheme(clientTheme: IClientTheme): void {
        theme.value = clientTheme;
        applyClientTheme(clientTheme.colors);
    }

    return { theme, setTheme };
});

export { useClientStore };
